import httpHelper from "../helpers/httpHelper";

const CONTROLLER = "/Auth/Notification";

const notificationApi = {
    List(data) {
        return httpHelper.get(CONTROLLER + "/List",data);
    },
    Add(data) {
        return httpHelper.post(CONTROLLER + "/Add", data);
    },
    AddFcmDevice(data) {
        return httpHelper.post(CONTROLLER + "/AddFcmDevice", data);
    },
    Get(data) {
        return httpHelper.get(CONTROLLER + "/Get", data);
    },
    MyNotification(data) {
        return httpHelper.get(CONTROLLER + "/MyNotification", data);
    },
    Edit(data) {
        return httpHelper.put(CONTROLLER + "/Edit", data);
    },
    Delete(data) {
        return httpHelper.delete(CONTROLLER + "/Delete", data);
    },
    DetailNotification(data){
        return httpHelper.get(CONTROLLER + "/DetailNotification", data);
    },
    TotalUnread(){
        return httpHelper.get(CONTROLLER + "/TotalUnread");
    },
    ReadNotification(data){
        return httpHelper.post(CONTROLLER + "/ReadNotification", data);
    }
}

export default notificationApi;
